import { UploadListResponse } from 'interfaces/fileList';
import { stringify } from 'qs';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getUploadList = ({ studyId, labId }: { studyId: string; labId: string }) => {
  return apiRequestHandlerPromise<UploadListResponse>({
    url: `studies/${studyId}/uploads?${stringify({ labId })}`,
    method: 'GET',
  });
};

export const getManifestDownloadUrl = ({
  studyId,
  objectKey,
  labId,
}: {
  studyId: string;
  objectKey: string;
  labId: string;
}) => {
  return apiRequestHandlerPromise<string>({
    url: `studies/${studyId}/uploads/manifest-download-url?${stringify({ labId })}`,
    method: 'POST',
    data: JSON.stringify({
      objectKey,
    }),
  });
};

export type StudyUploadVisibilityOperation = 'hide' | 'restore';

export interface StudyUploadVisibilityResponse {
  objectKey: string;
  isHidden: boolean;
}

export const setStudyUploadVisibility = ({
  studyId,
  objectKey,
  labId,
  operation,
}: {
  studyId: string;
  objectKey: string;
  labId: string;
  operation: StudyUploadVisibilityOperation;
}) => {
  return apiRequestHandlerPromise<StudyUploadVisibilityResponse>({
    url: `studies/${studyId}/uploads/${operation}?${stringify({ labId })}`,
    method: 'POST',
    data: JSON.stringify({ objectKey }),
  });
};

export interface ExecuteUploadedSlideIngestResponse {
  parentJobId: string;
  studyId: string;
  folderPath: string;
  uploadCount: number;
  queuedCount: number;
  failedToStartCount: number;
  message: string;
}

export const executeUploadedSlideIngest = ({
  studyId,
  uploadKeys,
  labId,
  reingest = false,
  jobName,
  jobDescription,
}: {
  studyId: string;
  uploadKeys: string[];
  labId: string;
  reingest?: boolean;
  jobName?: string;
  jobDescription?: string;
}) => {
  return apiRequestHandlerPromise<ExecuteUploadedSlideIngestResponse>({
    url: `ingest/uploaded_slide_ingests.execute?${stringify({ labId })}`,
    method: 'POST',
    data: JSON.stringify({
      studyId,
      uploadKeys,
      reingest,
      jobName,
      jobDescription,
    }),
  });
};
